module.exports = __webpack_public_path__ + "img/searchBar.6c76aef7.svg";